module.exports = __webpack_public_path__ + "img/个人简历背景-不带图标1.e21d97d0.png";